<template>
    <div>
        <v-card flat class="shadow mt-3">
            <!-- header -->
            <!-- header -->
            <div>
                <!-- filters -->
                <v-card flat class>
                    <v-card-actions class="p-0">
                        <v-btn small text @click="show = !show">
                            <v-icon small left
                                >fi fi-rr-settings-sliders</v-icon
                            >
                            <h4>فلاتر</h4>
                        </v-btn>
                        <!-- <v-spacer></v-spacer>
                        <v-btn small text color="grey">
                            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                        </v-btn> -->
                    </v-card-actions>

                    <v-expand-transition>
                        <div v-show="show">
                            <v-row class="align-center px-3">
                                <v-col cols="12" md="3">
                                    <v-autocomplete
                                        @input="getItems()"
                                        :items="$global.state.provinces"
                                        v-model="$global.state.provinceId"
                                        item-text="name"
                                        item-value="id"
                                        clearable
                                        dense
                                        placeholder="المحافظة"
                                        no-data-text="لا توجد بيانات"
                                        hide-details
                                        outlined
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                    <v-divider :class="show ? 'mt-3' : 'mt-1'" />
                </v-card>
                <v-row align="center" class="pa-3">
                    <v-col cols="12" md="2" class="mb-sm-1">
                        <v-btn
                            @click="openAddDialog()"
                            color="primary"
                            class="btn"
                            v-if="
                                hasRole([
                                    Roles.ProjectCreate,
                                    Roles.Admin,
                                    Roles.Administrator,
                                    Roles.SuperAdmin,
                                ])
                            "
                        >
                            <v-icon small class="pl-1">mdi-plus</v-icon>اضافة
                        </v-btn>
                    </v-col>
                    <v-spacer />
                    <v-col cols="12" md="4">
                        <div class="d-flex justify-space-between">
                            <v-text-field
                                v-debounce:500ms="getItems"
                                v-model="filter.search"
                                placeholder="ابحث هنا"
                                hide-details
                                dense
                                class="pl-3"
                                outlined
                            />
                            <v-select
                                @change="
                                    getProjects(
                                        1,
                                        filter.pageSize,
                                        filter.search
                                    )
                                "
                                :height="42"
                                v-model="filter.pageSize"
                                :items="pageSizes"
                                no-data-text="لا توجد بيانات"
                                style="max-width: 85px"
                                hide-details
                                outlined
                                dense
                            ></v-select>
                        </div>
                    </v-col>
                </v-row>
            </div>

            <div class="d-flex justify-content-end flex-wrap align-center">
                <v-card
                    class="ma-3"
                    max-width="344"
                    v-for="(item, i) in projects"
                    :key="i"
                >
                    <div v-if="item.videoUrl" style="height: 200px">
                        <!-- YouTube Video -->
                        <div v-if="isYouTubeUrl(item.videoUrl)">
                            <iframe
                                :src="getYouTubeEmbedUrl(item.videoUrl)"
                                width="100%"
                                height="200px"
                                frameborder="0"
                                allowfullscreen
                            ></iframe>
                        </div>
                        <!-- Regular Video -->
                        <div v-else>
                            <video
                                controls
                                style="
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                "
                            >
                                <source :src="item.videoUrl" type="video/mp4" />
                                <source
                                    :src="item.videoUrl"
                                    type="video/webm"
                                />
                                <source :src="item.videoUrl" type="video/ogg" />
                                المتصفح لا يدعم تشغيل الفيديو
                            </video>
                        </div>
                    </div>
                    <v-img
                        v-else
                        cover
                        :lazy-src="item.imageUrl"
                        :src="item.imageUrl"
                        height="200px"
                    ></v-img>

                    <div class="d-flex justify-space-between">
                        <v-card-title>
                            <UserInfo :item="item" />
                        </v-card-title>

                        <div style="min-width: 75px" class="mt-5">
                            <v-tooltip
                                bottom
                                v-if="
                                    hasRole([
                                        Roles.ProjectUpdate,
                                        Roles.Admin,
                                        Roles.Administrator,
                                        Roles.SuperAdmin,
                                    ])
                                "
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" icon>
                                        <edit
                                            v-on="on"
                                            @refresh="
                                                getProjects(
                                                    filter.pageIndex,
                                                    filter.pageSize,
                                                    filter.search
                                                )
                                            "
                                            :project="item"
                                        ></edit>
                                    </v-btn>
                                </template>
                                <span>تعديل</span>
                            </v-tooltip>

                            <v-tooltip
                                bottom
                                v-if="
                                    hasRole([
                                        Roles.ProjectDelete,
                                        Roles.Admin,
                                        Roles.Administrator,
                                        Roles.SuperAdmin,
                                    ])
                                "
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        @click="deleteItem(item.id, i)"
                                        v-on="on"
                                        x-small
                                        icon
                                        depressed
                                    >
                                        <v-icon color="error"
                                            >fi fi-rr-trash</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>حذف</span>
                            </v-tooltip>
                        </div>
                    </div>

                    <v-card-subtitle class="d-flex px-3 mt-0">
                        <v-chip small :ripple="false">
                            {{ i + 1 }}
                        </v-chip>
                        <v-spacer></v-spacer>
                        {{ item.createdAt | formatDate }}
                    </v-card-subtitle>

                    <v-card-actions>
                        <v-btn color="orange lighten-2" text> الوصف </v-btn>

                        <v-spacer></v-spacer>

                        <v-btn icon @click="show = !show">
                            <v-icon>{{
                                show ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-expand-transition>
                        <div v-show="show">
                            <v-divider></v-divider>

                            <v-card-text>
                                {{ item.caption }}
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>
            </div>

            <!-- ============================================ -->
            <!-- ============================================ -->
            <!-- ============================================ -->
            <!-- ============================================ -->
            <!-- table -->

            <v-divider></v-divider>
            <!-- <Pagination :items="projects" /> -->
            <div class="d-flex justify-space-between py-3">
                <v-spacer></v-spacer>
                <v-pagination
                    v-model="filter.pageIndex"
                    :length="length"
                    :total-visible="7"
                    @input="
                        getProjects(
                            filter.pageIndex,
                            filter.pageSize,
                            filter.search
                        )
                    "
                ></v-pagination>
            </div>
            <Dialog
                @refresh="
                    getProjects(
                        filter.pageIndex,
                        filter.pageSize,
                        filter.search
                    )
                "
            />
        </v-card>
    </div>
</template>

<script>
import { Roles } from "../../utils/roles";
import Edit from "./edit.vue";
export default {
    data() {
        return {
            headers: [
                {
                    text: " الوصف",
                    value: "caption",
                },
                {
                    text: " الصورة",
                    value: "imageUrl",
                },
                {
                    text: "آخر تحديث بواسطة",
                    value: "createdAt",
                },

                {
                    text: "الإجراءات",
                    value: "actions",
                    sortable: false,
                    align: "center",
                },
            ],
            show: false,
            id: "",
            caption: "",
            imageUrl: "",
            createdAt: "",
            actions: "",
            projects: [],
            projectObj: {},
            loading: false,
            uploading: false,
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            length: 0,
            Roles,
            filter: {
                pageIndex: 1,
                pageSize: 15,
                search: "",
                count: 0,
            },
            pageSizes: [5, 10, 15, 30, 50, 100],
        };
    },

    components: {
        Dialog: () => import("./dialog"),
        Edit,
        UserInfo: () => import("@/components/UserInfo.vue"),
    },

    created() {
        this.getProjects(
            this.filter.pageIndex,
            this.filter.pageSize,
            this.filter.search
        );

        // this.$eventBus.$on(`refresh`, () => {
        //     this.getProjects(
        //         this.filter.pageIndex,
        //         this.filter.pageSize,
        //         this.filter.search
        //     );
        // });
    },

    beforeDestroy() {
        this.$eventBus.$off(`refresh`);
    },

    methods: {
        isYouTubeUrl(url) {
            const youtubeRegex =
                /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)/;
            return youtubeRegex.test(url);
        },
        getYouTubeEmbedUrl(url) {
            let videoId = "";
            if (url.includes("youtube.com/watch?v=")) {
                videoId = url.split("v=")[1].split("&")[0];
            } else if (url.includes("youtu.be/")) {
                videoId = url.split("youtu.be/")[1].split("?")[0];
            } else if (url.includes("youtube.com/embed/")) {
                return url;
            }
            return `https://www.youtube.com/embed/${videoId}`;
        },
        getItems() {
            this.$global.dispatch(`get${this.$route.meta.endPoint}`);
        },
        async getProjects(pageIndex, pageSize, search) {
            this.loading = true;
            try {
                let query = `Projects?IsDelete=false`;

                if (pageIndex !== undefined && pageIndex !== null) {
                    query += `&PageIndex=${pageIndex}`;
                }

                if (pageSize !== undefined && pageSize !== null) {
                    query += `&PageSize=${pageSize}`;
                }

                if (search !== undefined && search !== null) {
                    query += `&Search=${search}`;
                }

                const res = await this.$http.get(query);
                this.projects = res.data.result.data;
                this.filter.count = res.data.result.count;
                this.length =
                    res.data.result.count == undefined
                        ? 0
                        : Math.ceil(
                              res.data.result.count / this.filter.pageSize
                          );
            } catch (err) {
                this.dispatch("toastification/setToast", {
                    message: `${err.data.message}`,
                    type: "error",
                });
            } finally {
                this.loading = false;
            }
        },
        async deleteItem(id, i) {
            this.$genericService.swalAlertConfirm({}).then((result) => {
                if (result.isConfirmed) {
                    this.$genericService
                        .delete(`${this.$route.meta.endPoint}`, id)
                        .then((res) => {
                            this.$store.dispatch("toastification/setToast", {
                                message: `${res.data.message}`,
                                type: "success",
                            });

                            let index = this.projects.findIndex(
                                (x) => x.id == id
                            );
                            this.projects.splice(index, 1);
                        })
                        .catch((err) => {
                            this.$store.dispatch("toastification/setToast", {
                                message: `${err.data.message}`,
                                type: "error",
                            });
                        });
                }
            });
        },

        openAddDialog() {
            var item = { dialogType: "add" };
            this.$store.commit("setItemDetails", item);
            this.$store.commit("setDialog");
        },

        openEditDialog(item) {
            item.dialogType = "edit";
            this.$store.commit("setItemDetails", item);
            this.$store.commit("setDialog");
            this.$eventBus.$emit("fill-fields");
        },
    },
};
</script>
<style></style>
